var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmissionClass = function SvgEmissionClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.534 20-5.445-4.053-5.682 4.026 2.204-6.39L3 9.463l6.802.106L12.014 3l2.007 6.452L21 9.51l-5.568 3.886L17.534 20Z",
    fill: "#F08200"
  })));
};
export default SvgEmissionClass;